export default {
  "content": "<path d=\"M27.7 2v17l-6.9 4-.1-17 7-4z\" fill=\"#E02D2D\"/><path d=\"M20.8 23l-2.1-1.2v-17l2 1.2.1 17z\" fill=\"#E02D2D\"/><path d=\"M20.7 6l.1 17-7.3 4.2v-17L20.7 6zM13.5 27.2L11.4 26V9l2.1 1.2v17z\" fill=\"#fff\"/><path d=\"M13.5 10.2v17l-6.9 4v-17l6.9-4z\" fill=\"#34B353\"/><path d=\"M25.6.8l-6.9 4L11.4 9l-6.9 4 .1 17 2.1 1.2v-17l6.9-4L20.7 6l6.9-4-2-1.2z\" fill=\"#1D1D1B\"/><path d=\"M13.5 10.3l14.1-8.1V19l-14.2 8.2-6.8 3.9V14.3l6.9-4z\" stroke=\"#1D1D1B\" stroke-width=\".161\" stroke-miterlimit=\"10\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};